module.exports = __webpack_public_path__ + "46727ab7fd9306ab4ee40440898efe6d.png";